import { User } from '../../types/User';

export type UserDto = {
    groups?: Array<{ id: string; name: string }>;
    is_machine_account: boolean;
    is_stale: boolean;
    last_access?: string;
    name: string;
    ous?: Array<{ id: string; name: string }>;
    resources?: Array<{ id: string; name: string }>;
    user_guid: string;
};

export const mapUserDtoResponseToUser = (entity: UserDto): User => ({
    ...entity,
    last_access: entity.last_access ? new Date(entity.last_access) : undefined
});
